import { render, staticRenderFns } from "./ShopRetailLink.vue?vue&type=template&id=522a619c"
import script from "./ShopRetailLink.vue?vue&type=script&lang=js"
export * from "./ShopRetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports